import { render, staticRenderFns } from "./RadioInput.vue?vue&type=template&id=7047ad7b"
import script from "./RadioInput.ts?vue&type=script&lang=ts&external"
export * from "./RadioInput.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports